import { render, staticRenderFns } from "./CustomerIdContent.vue?vue&type=template&id=998d174a"
import script from "./CustomerIdContent.vue?vue&type=script&lang=js"
export * from "./CustomerIdContent.vue?vue&type=script&lang=js"
import style0 from "./CustomerIdContent.vue?vue&type=style&index=0&id=998d174a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports